export default "__VITE_ASSET__CEV3WW0P__"